import jdkVersions from "src/_download_tabs/liberica_versions.json"

export type JdkVersion = {
    LTS: boolean,
    GA: boolean,
    featureVersion: number
}

export type JdkVersionStringProps = {
    andSeparator?: boolean;
    appendLts?: boolean;
}

export const getJdkVersions = () => {
    return jdkVersions.sort(
        (versionA, versionB) =>
            versionA.featureVersion - versionB.featureVersion
    );
}

export const getLtsJdkVersions = () => {
    return getJdkVersions().filter(version => version.LTS);
}

export const getNonLtsJdkVersions = () => {
    return getJdkVersions().filter(version => !version.LTS);
}

export const getLatestJdkVersion = () => {
    const versions = getJdkVersions();
    return versions[versions.length - 1];
}

export const getLtsJdkVersionsWithLatest = () => {
    const versions = getJdkVersions().filter(version =>
        version.LTS);
    const latest = getLatestJdkVersion();
    if (versions[versions.length - 1].featureVersion !== latest.featureVersion) {
        versions.push(latest)
    }
    return versions;
}

export const getJdkVersionsString = (props?: JdkVersionStringProps & {versions?: JdkVersion[]}) => {
    const {
        andSeparator,
        appendLts,
        versions
    } = (props || {})
    const versionToString = (version: JdkVersion) => {
        return appendLts ? `${version.featureVersion} (LTS)` : `${version.featureVersion}`
    }

    const jdkVersionsArr = versions || jdkVersions;

    const prefix = jdkVersionsArr.slice(0, -1)
        .map(versionToString)
        .join(', ');
    return `${prefix}${prefix && (andSeparator ? " and " : ", ")}${jdkVersionsArr.slice(-1)
        .map(versionToString).join("")}`;
}

export const getLtsJdkVersionsString = (props?: JdkVersionStringProps) => {
    return getJdkVersionsString({
        ...props,
        versions: getLtsJdkVersions(),
    })
}

export const getNonLtsJdkVersionsString = (props?: JdkVersionStringProps) => {
    return getJdkVersionsString({
        ...props,
        versions: getNonLtsJdkVersions(),
    })
}

export const getLtsJdkVersionsWithLatestString = (props?: JdkVersionStringProps) => {
    return getJdkVersionsString({
        ...props,
        versions: getLtsJdkVersionsWithLatest(),
    })
}

export const getLatestJdkVersionString = () => {
    return `${getLatestJdkVersion().featureVersion}`;
}